import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import './About.css';

// Professional team collaboration image from Unsplash
const aboutImage = '/images/about-us.jpeg';

const About = () => {
  const highlights = [
    'Strategic technology roadmaps',
    'Purpose-driven modernization',
    'Operations optimization',
    'Omni-channel experience transformation'
  ];

  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <div className="about-image-main">
              <img src={aboutImage} alt="Team collaboration" className="about-img" />
              <div className="image-pattern"></div>
            </div>
          </div>

          <div className="about-text">
            <span className="section-subtitle">About Us</span>
            <h2 className="section-title" style={{ textAlign: 'left' }}>
              Provide the Best Easy Solution for Your IT Problems
            </h2>
            <p className="about-description">
              SemperSys Corp transforms businesses through technology. We partner with
              organizations to strategically rethink their operations through collaborative
              workshops and deliver purpose-driven modernization initiatives.
            </p>
            <p className="about-description">
              Our team of seasoned experts specializes in optimizing operations using
              intelligent technologies and transforming customer experiences across all channels.
            </p>

            <ul className="about-highlights">
              {highlights.map((item, index) => (
                <li key={index}>
                  <FiCheckCircle className="check-icon" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <a href="#contact" className="btn btn-primary">
              Discover More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
